import type { TableColumn } from "@/components/GenericTable/types";

/** Colunas da tabela/card de consentimentos por aba. */
export function getConsentTableColumns(
  selectedTab: string,
  type: string,
  options?: { includeMobileStatus?: boolean },
): TableColumn[] {
  const base: TableColumn[] =
    selectedTab === "3"
      ? [
          { column: "Documento", rowName: "identifier" },
          { column: "Profissional", rowName: "name" },
          { column: "Data", rowName: "date" },
          { column: "Hora", rowName: "hour" },
          { column: "Validade", rowName: "vigency" },
        ]
      : [
          {
            column: selectedTab === "1" ? "CPF" : "CNPJ",
            rowName: "identifier",
          },
          { column: "Nome", rowName: "name" },
          { column: "Data", rowName: "date" },
          { column: "Hora", rowName: "hour" },
          { column: "Validade", rowName: "vigency" },
        ];

  if (type === "received") {
    if (options?.includeMobileStatus) {
      return [...base, { column: "Status", rowName: "ends" }];
    }
    return [...base, { column: "Status", rowName: "status" }];
  }

  if (options?.includeMobileStatus) {
    return [...base, { column: "Status", rowName: "ends" }];
  }

  return base;
}

/** Campos extras para cards mobile (accent + chip como DependentList). */
export function enrichConsentRowForMobileCard(row: Record<string, unknown>) {
  const statusRaw = String(row.status ?? "");
  const isValidRow =
    statusRaw === "valid" ||
    statusRaw === "Válido" ||
    row.isValid === true;

  return {
    ...row,
    ends: isValidRow ? "Ativo" : "Inativo",
  };
}
